/**
 * Created by Jerker Nord on 2024-06-03.
 */
import {BenjiKIVGameAssets} from "../BenjiKIVGameAssets";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {gsap} from "gsap";
import {BenjiKIV} from "../BenjiKIV";

export class BenjiKIVFastWinWaysContainer extends PIXI.Container {

    private static AMOUNT_MAX_WIDTH:number = 150;
    private static CONTAINER_START_POSITION:PIXI.Point = new PIXI.Point(70, -80);
    private static CONTAINER_END_POSITION:PIXI.Point = new PIXI.Point(70, -120);
    private static FADE_OUT_DURATION:number = 0.26;
    private static TOTAL_SHOW_DURATION:number = 0.6;

    private _toggleAmount:PIXI.BitmapText;
    private _toggleWays:PIXI.Text;
    private _showTL:gsap.core.Timeline;
    private _isUsed:boolean;
    private _container:PIXI.Container;

    constructor() {
        super();
        this._isUsed = false;
        this.init();
    }

    private init():void {
        this.visible = false;
        this._container = new PIXI.Container();
        this._container.position = BenjiKIVFastWinWaysContainer.CONTAINER_START_POSITION;
        this.addChild(this._container);

        this._toggleAmount = new PIXI.BitmapText("", {
            fontName : BenjiKIVGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize : 14,
            tint : 0xffffff
        });
        this._toggleAmount.anchor = 0.5;
        this._toggleAmount.position.y = -18;
        //this._toggleAmount.visible = false;

        this._toggleWays = new PIXI.Text("", new PIXI.TextStyle({
            dropShadow : true,
            dropShadowAngle : 8,
            dropShadowBlur : 3,
            dropShadowDistance : 3,
            fill : "#FFFF00",
            fontFamily : OpenSans.FAMILY,
            fontSize : 18,
            fontWeight : FontWeight.BOLD,
            lineJoin : "round",
            miterLimit : 6,
            strokeThickness : 4
        }));
        //this._toggleWays.visible = false;
        this._toggleWays.anchor.set(0.5, 0.5);

        this._container.addChild(this._toggleAmount, this._toggleWays);

        this._toggleWays.position.y = this._toggleAmount.textHeight;

        this._showTL = gsap.timeline({paused : true});
        this._showTL.add(() => {
            this.visible = true;
            this.alpha = 1;
        });
        this._showTL.add(() => {
            gsap.fromTo(this._container.position, BenjiKIVFastWinWaysContainer.TOTAL_SHOW_DURATION,
                {
                    x : BenjiKIVFastWinWaysContainer.CONTAINER_START_POSITION.x,
                    y : BenjiKIVFastWinWaysContainer.CONTAINER_START_POSITION.y
                }, {
                    x : BenjiKIVFastWinWaysContainer.CONTAINER_END_POSITION.x,
                    y : BenjiKIVFastWinWaysContainer.CONTAINER_END_POSITION.y
                })
        });
        this._showTL.add(gsap.timeline({delay : BenjiKIVFastWinWaysContainer.TOTAL_SHOW_DURATION - BenjiKIVFastWinWaysContainer.FADE_OUT_DURATION}));
        this._showTL.add(gsap.to(this._container, {
                duration : BenjiKIVFastWinWaysContainer.FADE_OUT_DURATION,
                alpha : 0
            })
        );
    }

    public setValues(amount:number, ways:number):void {
        this._toggleAmount.text = SlotGame.apiPlugin.currency.formatValue(amount);
        const text:string = (ways == 1 ? "Way Won" : "Ways Won");
        this._toggleWays.text = ways + " " + BenjiKIV.apiPlugin.translations.translate(text);
        if(this._toggleAmount.textWidth > BenjiKIVFastWinWaysContainer.AMOUNT_MAX_WIDTH) {
            this._toggleAmount.fontSize = this._toggleAmount.fontSize * (BenjiKIVFastWinWaysContainer.AMOUNT_MAX_WIDTH / this._toggleAmount.textWidth);
        }
    }

    public getShowTL():gsap.core.Timeline {
        return this._showTL.restart();
    }

    public reset():void {
        this.visible = false;
        this.alpha = 1;
        this._container.position = BenjiKIVFastWinWaysContainer.CONTAINER_START_POSITION;
        this._isUsed = false;
    }

    get isUsed():boolean {
        return this._isUsed;
    }

    set isUsed(value:boolean) {
        this._isUsed = value;
    }
}